import React, { useContext, useEffect, useRef } from 'react';

import { CookieContext } from 'shared/components/CookieContextProvider';

function HTMLSnippet({ htmlSnippet }) {
  const divRef = useRef();
  const { consentGiven } = useContext(CookieContext);

  useEffect(() => {
    if (consentGiven) {
      const fragment = document
        .createRange()
        .createContextualFragment(htmlSnippet);
      divRef.current.append(fragment);
    }
  }, [consentGiven]);

  if (!consentGiven) return null;
  return <div ref={divRef}></div>;
}

export default HTMLSnippet;
